import { DefaultElementStyles } from '../../Commons/styles/styles';

export const styles = {
  HeroWrapper: {
    textAlign: 'center',
  },
  HeroSectionContainer: {
    position: 'relative',
  },
  HeroSectionContainerWithText: {
    position: 'relative',
    '::before': {
      content: '""',
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      background: 'linear-gradient(rgba(0, 0, 0, 0.3),  rgba(0, 0, 0, 0.1) )',
      pointerEvents: 'none',
      zIndex: '1',
    },
  },
  HeroSectionParagraph: {
    fontSize: '16px',
    color: '#fff',
    lineHeight: '24px',
    fontFamily: 'Poppins',
    fontWeight: '400',
  },
  Video: {
    objectFit: 'cover' as any,
    width: '100%',
    overflow: 'hidden',
  },
  Image: {
    objectFit: 'cover' as any,
    width: '100%',
  },
  Carousel: {
    width: '100%',
  },
  Container: {
    position: 'absolute',
    zIndex: 1,
    padding: '100px 16px 40px 2rem',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '50px',
    '@media (max-width: 780px)': {
      flexDirection: 'column',
      gap: '50px',
      alignItems: 'center',
    },
  },
  container_Mobile: {
    position: 'absolute',
    zIndex: 1,
    padding: '100px 16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '15px',
  },
  textContainer: {
    flex: 1,
    maxWidth: '50%',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignSelf: 'center',
    gap: '20px',

    '@media (max-width: 780px)': {
      width: '100%',
      padding: 0,
    },
  },
  btnContainer: {
    margin: '20px 0',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
    width: '100%',
    alignItems: 'center',
    '@media (max-width: 780px)': {
      justifyContent: 'center',
    },
  },
  btnContainer_Mobile: {
    margin: '20px 0',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
    //width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textContainer_Mobile: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    padding: 0,
    gap: '20px',
  },
  secondaryImage: {
    flex: 1,
    maxWidth: '50%',
    minWidth: 0,
    objectFit: 'contain',
    overflow: 'hidden',
    '@media (max-width: 780px)': {
      objectFit: 'contain',
      width: '100%',
      height: '250px',
    },
    '& img': {
      transition: 'transform 0.6s ease',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    '&:hover img': {
      transform: 'scale(1.08)',
    },
  },
  secondaryImage_Mobile: {
    objectFit: 'contain',
    width: '100%',
    height: '250px',
    overflow: 'hidden',
    '& img': {
      transition: 'transform 0.6s ease',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    '&:hover img': {
      transform: 'scale(1.08)',
    },
  },
  Heading: {
    ...DefaultElementStyles.HeaderDefaultStyles,
    color: '#fff',
    marginTop: 0,
    marginBottom: 0,
  },
  HeroSectionSubHeading: {
    ...DefaultElementStyles.ParagraphDefaultStyles,
    color: '#fff',
    marginTop: 0,
    marginBottom: 0,
  },
  HeroSectionOverline: {
    ...DefaultElementStyles.ParagraphDefaultStyles,
    color: '#fff',
    marginTop: 0,
    marginBottom: 0,
    fontSize: '14px',
    letterSpacing: '1px',
  },

  // Position styles
  PositionStyles: {
    left: {
      alignItems: 'flex-start',
      textAlign: 'left' as const,
      justifyContent: 'flex-start',
      flexDirection: 'row-reverse',
      marginLeft: '0',
      marginRight: 'auto',
      paddingLeft: '2rem',
    },
    center: {
      alignItems: 'center',
      textAlign: 'center' as const,
      justifyContent: 'center',
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingLeft: '0',
      paddingRight: '0',
    },
    right: {
      alignItems: 'flex-start',
      textAlign: 'left' as const,
      justifyContent: 'flex-start',
      flexDirection: 'row',
      marginLeft: 'auto',
      marginRight: '0',
      paddingRight: '2rem',
    },
  },
  // Section height styles
  SectionHeightStyles: {
    DEFAULT: {
      height: '75vh',
    },
    FULL: {
      height: '100vh',
    },
  },
  // Button styles
  ButtonStyles: {
    textDecoration: 'none',
    margin: '20px 0',
  },
  SecondaryButtonStyles: {
    textDecoration: 'none',
    margin: '20px 0  20px 20px',
    '@media(max-width:780px)': {
      marginLeft: '0px',
    },
  },
  // Loading styles
  LoadingStyles: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
};
